import uuid from 'uuid-random';
import { log } from 'log';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslations } from 'js/hooks/i18n';
import { validateGeolocation } from 'js/hooks/auth/pas';
import { useSmartClosePopups } from 'js/components/common/PopupManager';

import { showGeofencingPopupAction } from '../../../actions';

export const CAF_ERROR_POPUP_ID = uuid();

export const useOnCafError = ({
    transactionID,
    setShowOverlay,
    useTransparentPopup
}: {
    transactionID: string | null;
    setShowOverlay: React.Dispatch<React.SetStateAction<boolean>>;
    useTransparentPopup: boolean;
}) => {
    const closePopups = useSmartClosePopups();
    const onRefresh = useCallback(() => window.location.reload(), []);
    const dispatch = useDispatch();
    const t = useTranslations();

    return useCallback(async (errorCode: number, message: object) => {
        log('gcErr', { transactionID, errorCode, message });

        switch (errorCode) {
            default:
                setShowOverlay(false);

                dispatch(showGeofencingPopupAction({
                    id: CAF_ERROR_POPUP_ID,
                    title: 'playtech.mobile.system.geocomply.popups.error.title',
                    content: t(`playtech.mobile.system.geocomply.popups.error.${errorCode}`, String(message)),
                    isModal: true,
                    buttons: [
                        {
                            onClick: () => closePopups(CAF_ERROR_POPUP_ID),
                            text: 'playtech.mobile.system.geocomply.popups.error.ignore',
                            color: 'negative'
                        },
                        {
                            onClick: onRefresh,
                            text: 'playtech.mobile.system.geocomply.popups.error.refresh',
                            color: 'info'
                        }
                    ],
                    useTransparentPopup
                }));

                try {
                    await validateGeolocation(null, null, JSON.stringify(message), transactionID, String(errorCode));
                } catch (e) {
                    // noop
                }
        }
    }, [
        t,
        onRefresh,
        closePopups,
        transactionID,
        dispatch,
        setShowOverlay,
        useTransparentPopup
    ]);
};
